import { createContext, useContext } from 'react'

import { TechnicalError } from '@orus.eu/error'
import { isOperatingZone, type OperatingZone } from '@orus.eu/operating-zone'

type OperatingZoneContextValue = {
  operatingZone: OperatingZone
  setOperatingZone: (operatingZone: OperatingZone) => void
}

export const OperatingZoneContext = createContext<OperatingZoneContextValue | undefined>(undefined)

export function useOperatingZone(): OperatingZone {
  return useContext(OperatingZoneContext)?.operatingZone ?? 'fr'
}

export function useSetOperatingZone(): (operatingZone: OperatingZone) => void {
  const contextValue = useContext(OperatingZoneContext)
  if (!contextValue) {
    throw new TechnicalError('OperatingZoneProvider not found')
  }
  return contextValue.setOperatingZone
}

export function getInitialOperatingZoneFromUrl(): OperatingZone {
  const url = new URL(document.location.href)
  const operatingZoneParameter = url.searchParams.get('operating_zone')
  if (operatingZoneParameter && isOperatingZone(operatingZoneParameter)) {
    return operatingZoneParameter
  }

  return 'fr'
}
